<div class="flex flex-col gap-(--gap-relaxed) p-(--padding-card)">
  <div class="flex flex-col gap-(--gap-tight)">
    <label class="font-semibold text-sm">{{ 'entities.campaign.merge.campaignA' | transloco }}</label>
    <p-select
      [options]="optionsForA()"
      [filter]="optionsForA().length >= 10"
      [ngModel]="selectedAId()"
      (ngModelChange)="selectedAId.set($event)"
      optionLabel="label"
      optionValue="value"
      [optionDisabled]="'disabled'"
      [placeholder]="'entities.campaign.merge.selectCampaign' | transloco"
      [showClear]="true"
      appendTo="body"
      styleClass="w-full" />
  </div>

  <div class="flex flex-col gap-(--gap-tight)">
    <label class="font-semibold text-sm">{{ 'entities.campaign.merge.campaignB' | transloco }}</label>
    <p-select
      [options]="optionsForB()"
      [filter]="optionsForB().length >= 10"
      [ngModel]="selectedBId()"
      (ngModelChange)="selectedBId.set($event)"
      optionLabel="label"
      optionValue="value"
      [optionDisabled]="'disabled'"
      [placeholder]="'entities.campaign.merge.selectCampaign' | transloco"
      [showClear]="true"
      appendTo="body"
      styleClass="w-full" />
  </div>

  <div
    class="flex items-center gap-(--gap-tight) p-(--space-2) bg-amber-50 border border-amber-200 rounded-(--radius-md) text-xs text-amber-800">
    <span class="material-symbols text-sm text-amber-600">warning</span>
    <span>{{ 'entities.campaign.merge.mergeWarning' | transloco }}</span>
  </div>

  @if (mergedPreview(); as preview) {
    <div
      class="flex items-center gap-(--gap-tight) p-(--space-2) bg-emerald-50 border border-emerald-200 rounded-(--radius-md) text-sm">
      <span class="material-symbols text-emerald-600 text-base leading-none">merge</span>
      <span>
        {{ 'entities.campaign.merge.previewLabel' | transloco }} <strong>{{ preview }}</strong>
      </span>
    </div>
  }

  <ces-dialog-footer
    [submitLabel]="'entities.campaign.merge.mergeButton' | transloco"
    [submitDisabled]="!canMerge()"
    (onSubmit)="confirm()"
    (onCancel)="cancel()" />
</div>
